<template>
	<div>
		<Form :label-width="90" class="mt15 w1000">
			<FormItem :label-width="110">
				<template slot="label">
					<span style='color: red;'>*&nbsp;</span>投保单上传：
				</template>
				<div class="desc">
					<a @click="download" target="_blank">立即下载</a>请在下载后盖章再上传
					<span v-if="multiple" style="color:red">注：下载盖章件后如关闭此页面，请重新购买此产品（重新购买时信息要与盖章件保持一致）</span>
				</div>
				<Form class="policy" :model="form" ref="form" :label-width="0">
					<Form-item 
						class="policy-item" 
						v-for="(p,i) in form.fileList"
						:prop="'fileList.' + i + '.fileUrl'"
						:key="i"
						:rules="{required:true,message:'请上传',trigger:'change'}">
						<UploadImg 
							v-model="p.fileUrl" 
							@on-remove="removeImg(i)"
							@on-success="val=>{uploaded(val, i)}"
							:show-del="form.fileList.length>1" />
						<Input v-model="p.fileUrl" v-show="false"></Input>
					</Form-item>
					<div class="policy-item" v-if="multiple&&form.fileList.length<10">
						<a @click="add">添加</a>
					</div>
				</Form>
			</FormItem>
		</Form>
	</div>
</template>
<script>
import UploadImg from './uploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				fileList:[{
					fileUrl:''
				}]
			}
		}
	},
	methods:{
		uploaded(file, index){
			let obj = {
				fileUrl:file.url
			}
			this.$set(this.form.fileList, index, obj)
		},
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.fileList.push({
				fileUrl:''
			})
		},
		removeImg (i) {
			this.form.fileList.splice(i,1);
		},
		// 下载模板
		download() {
			this.$axios.post('/specialEquipment/insurance/billDownload.json',{
				billNo: this.$route.params.id
			}).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '设备列表')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	},
	watch:{
		'info.url' (v) {
			let list = v.split(',');
			let list2 = list.map((item)=>{
				return {
					fileUrl:item,
				}
			})
			this.form.fileList = list2;
		}
	}
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
	.font14{
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/common/upload.vue